<mat-form-field
  appearance="outline"
  floatLabel="never"
  class="NavDropdown"
  [ngClass]="{
    'NavDropdown--Disabled': disabled,
    'NavDropdown--Desktop': !isMobileView,
    'NavDropdown--Mobile': isMobileView,
  }"
  data-test-id="navDropdown"
>
  <mat-select
    [formControl]="valueControl"
    (selectionChange)="handleOptionsChange($event)"
    [ngClass]="{ NavDropdown__WithSelectTriggerIcon: !!selectTriggerIcon }"
    panelClass="NavDropdown__DropContent"
  >
    <mat-select-trigger
      [ngClass]="{
        'u-flex u-alignCenter': !!selectTriggerIcon,
        'u-row-reverse': selectTriggerIconPosition === 'right',
      }"
    >
      @if (!!selectTriggerIcon) {
        <icon
          [name]="selectTriggerIcon"
          [ngClass]="{
            NavDropdown__SelectTriggerIcon: true,
            'NavDropdown__SelectTriggerIcon--Left':
              selectTriggerIconPosition === 'left',
            'NavDropdown__SelectTriggerIcon--Right':
              selectTriggerIconPosition === 'right',
          }"
        ></icon>
      }
      {{ openerLabel }}
    </mat-select-trigger>
    @for (option of options; track option) {
      <mat-option [value]="option[key]">
        <icon
          [ngClass]="{
            'NavDropdown__DropCheckIcon--hidden':
              valueControl.value !== option[key],
          }"
          name="check"
        ></icon>
        <p [ngClass]="{ 't-bold': valueControl.value === option[key] }">
          {{ option[displayProperty] }}
        </p>
      </mat-option>
    }
  </mat-select>
  <ng-container matPrefix
    ><ng-content select="[prefix]"></ng-content
  ></ng-container>
</mat-form-field>
